import {
  DesignLanguageStyleSheet,
  PreloadFormaFonts,
} from "./DesignLanguageStyles.Parts";

export const DesignLanguageStyles = () => {
  return (
    <>
      <DesignLanguageStyleSheet />
      <PreloadFormaFonts />
    </>
  );
};
